import type { GetConfig, PostConfig } from '../../fetch';
import { fetch2 } from '../../fetch';
import { endpoint } from '../../helpers/Endpoints';

// This should mirror CustomerController.cs (v2)!

export function GetCustomersAssignedToUser() {
	const opts: GetConfig = {
		uri: endpoint.customersV2(),
		method: 'GET',
	};
	return fetch2<ICustomer[]>(opts);
}

export function SwitchCustomerContext(customerId: number) {
	const opts: PostConfig = {
		uri: endpoint.customersV2(),
		method: 'POST',
		body: customerId.toString(),
	};
	return fetch2<ICustomer>(opts);
}

export function GetCustomerNoteForCustomer(customerId: number) {
	const opts: GetConfig = {
		uri: `/api/v2/customers/${customerId}/note`,
		method: 'GET',
	};
	return fetch2<CustomerNoteResult>(opts);
}

export function UpdateCustomerNoteForCustomer(args: CustomerNoteResult) {
	const opts: PostConfig = {
		uri: `/api/v2/customers/${args.customerId}/note`,
		method: 'POST',
		body: JSON.stringify({ CustomerNote: args.customerNote }),
	};
	return fetch2<NoResult>(opts);
}

export interface ICustomer {
	id: number;
	name: string;
	attributes: number[];
	selectionRuleSets: SelectionRuleSet[] | null;
}

export interface SelectionRuleSet {
	id: number;
	name: string;
	displayToken: string;
	isDefault: boolean;
	selectionRules: SelectionRule[];
}

export interface SelectionRule {
	rule: SelectionRuleEnum;
	ruleOrder: number;
}

export enum SelectionRuleEnum {
	UserDefinedOrder = 1,
	Stocked = 2,
	Demand = 3,
	Remote = 4,
	NonStock = 5,
	LeadTime = 6,
	ExcludeDemand = 7,
	ExcludeRemote = 8,
	ExcludeNonStock = 9,
}

export interface CustomerNoteResult {
	customerId: number;
	customerNote: string;
}

export interface NoResult {
	errors: string[];
}
